import fetchInterceptor,{FetchOptions} from "../../../utils/fetchInterceptor ";
import { blogEndpoints } from "../apiEndpoints";
import { header } from "../../../context/constant";

const DeleteBlogAPI = async (id: string) => {
  const url = blogEndpoints.delete(id);
  const options: FetchOptions = {
    method: "DELETE",
    headers: header,
  };
  return fetchInterceptor(url, options);
};

export default DeleteBlogAPI;
